import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const GroupsActionsToggle = ({ group, t, handleClick }) => {
  return (
    <Form.Button
      onClick={(e) => {
        e.preventDefault();
        handleClick(group.id);
      }}
      text={t(group.active ? 'actions.deactivate' : 'actions.activate')}
      color={group.active ? 'outline-warning' : 'outline-info'}
      extraClassName={'btn-sm'}
      isLoading={group.isLoading}
    />
  );
};

export default translate()(GroupsActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/actions/GroupsActionsToggle.js